import * as Yup from 'yup';

export const applicationInvalidateSchema = Yup.object().shape({
  invalidation_reason: Yup.string().required({ name: 'invalidation_reason', message: 'O campo é obrigatório' }),
});
